import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { AppUpdateService } from './services/app-update.service';
import { ThemeService } from './services/theme.service';
import { UpdateBannerComponent } from './components/update-banner/update-banner.component';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, UpdateBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  private authService = inject(AuthService);
  private updateService = inject(AppUpdateService);
  private themeService = inject(ThemeService);
  protected title = 'DBWeb';
  
  // Expose authentication state for template
  protected isAuthenticated = this.authService.isAuthenticated;

  ngOnInit(): void {
    // Initialize theme first for immediate visual consistency
    this.themeService.initializeTheme();
    
    // Initialize authentication without waiting
    this.authService.initializeAuthentication().catch(err => 
      console.error('Auth initialization failed:', err)
    );
  }
}
